import { fetchWithTimeout } from '../util/fetch'
import isInternetExplorer from '../util/internetExplorerHelper'
import {
  setupJsonJWTHeaders,
  genericHandleApiError,
  requestOk,
} from './api-util'
import config from '../../../config'

class AgreementServiceApi {
  static getApplicationAgreement = (id, token) => {
    const myInit = {
      method: 'GET',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(
      `${config.agreementServiceUrl}/agreements/applications/${id}`,
      myInit,
      config.requestTimeout,
    ).then(response => {
      if (requestOk(response)) {
        if (isInternetExplorer()) {
          return `${config.agreementServiceUrl}/agreements/pdf/${id}`
        }
        return response.blob().then(blob => {
          return URL.createObjectURL(blob)
        })
      }
      return genericHandleApiError(response)
    })
  }

  static getPaymentAgreement = (id, token) => {
    const myInit = {
      method: 'GET',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(
      `${config.agreementServiceUrl}/agreements/payments/${id}`,
      myInit,
      config.requestTimeout,
    ).then(response => {
      if (requestOk(response)) {
        if (isInternetExplorer()) {
          return `${config.agreementServiceUrl}/agreements/pdf/${id}`
        }
        return response.blob().then(blob => {
          return URL.createObjectURL(blob)
        })
      }
      return genericHandleApiError(response)
    })
  }
}

export default AgreementServiceApi
